// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pswp--custom-icon-colors{--pswp-icon-color:#fff;--pswp-icon-color-secondary:#333}.pswp__top-bar{padding-top:30px}", ""]);
// Exports
module.exports = exports;
